// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CircleAlertIcon,
  Link,
  Navigate,
  React,
  RefreshCwIcon,
  ShoppingBagIcon,
  motion,
} from "../vendor/runtime.js";
import { useAuth } from "../context/AuthContext.jsx";
import { SERVER_URL } from "../config.js";
import { api } from "../api/client.js";
import { Navbar } from "../components/Navbar.jsx";
import { Button } from "../components/Button.jsx";
const PurchasesPage = () => {
  const [a, n] = React.useState([]),
    { currentUser: i } = useAuth(),
    [l, c] = React.useState(true),
    [u, m] = React.useState(null),
    [f, x] = React.useState(false),
    [p, g] = React.useState(null),
    [b, y] = React.useState(null),
    w = SERVER_URL,
    N = () => {
      (x(true), window.Tawk_API && window.Tawk_API.maximize && window.Tawk_API.maximize());
    };
  if (!i) return <Navigate to={"/login"} replace={true} />;
  React.useEffect(() => {
    (async () => {
      try {
        const U = await api.get("/purchases");
        (console.log("Purchases data:", U.data), n(U.data));
      } catch (U) {
        (console.error("Error fetching purchases:", U),
          m("Failed to load your purchases. Please try again later."));
      } finally {
        c(false);
      }
    })();
  }, []);
  const T = (R) => {
      var B;
      if (!R) return false;
      if (R.category) return R.category.toLowerCase().trim() === "hardware";
      const U = ((B = R.title) == null ? undefined : B.toLowerCase()) || "";
      return [
        "hardware",
        "circuit",
        "pcb",
        "arduino",
        "raspberry pi",
        "iot",
        "sensor",
        "embedded",
      ].some((G) => U.includes(G));
    },
    C = (R) => {
      if (!R)
        return {
          color: "bg-gray-100 text-gray-700",
          text: "Order Placed",
        };
      switch (R.toLowerCase().trim()) {
        case "order received":
          return {
            color: "bg-blue-100 text-blue-700",
            text: "Order Received",
          };
        case "in process":
          return {
            color: "bg-yellow-100 text-yellow-700",
            text: "In Process",
          };
        case "shipped":
          return {
            color: "bg-purple-100 text-purple-700",
            text: "Shipped",
          };
        case "out for delivery":
          return {
            color: "bg-orange-100 text-orange-700",
            text: "Out for Delivery",
          };
        case "delivered":
          return {
            color: "bg-green-100 text-green-700",
            text: "Delivered",
          };
        default:
          return {
            color: "bg-gray-100 text-gray-700",
            text: "Active",
          };
      }
    },
    A = async (R) => {
      try {
        (await navigator.clipboard.writeText(R), y(R), setTimeout(() => y(null), 2e3));
      } catch (U) {
        console.error("Failed to copy tracking number:", U);
      }
    },
    O = (R) => {
      if (R.tracking_no) {
        const U = b === R.tracking_no;
        return (
          <button
            onClick={() => A(R.tracking_no)}
            className={
              "group relative text-[10px] border-amber-500  border p-1.5 rounded-md text-slate-800 font-semibold hover:bg-slate-50 transition-all duration-200 flex items-center gap-1"
            }
            title={"Click to copy tracking number"}
          >
            <span>{R.tracking_no}</span>
            <div
              className={
                "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50"
              }
            >
              {U ? "Copied!" : "Copy tracking number"}
            </div>
          </button>
        );
      } else
        return <span className={"text-xs text-slate-500 italic"}>{"Will be updated soon"}</span>;
    },
    M = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.5,
        },
      },
    },
    Y = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
        },
      },
    };
  return l ? (
    <div className={"min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100"}>
      <Navbar />
      <div
        className={
          "fixed inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-50"
        }
      >
        <div
          className={
            "w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center"
          }
        >
          <motion.div
            initial={{
              scale: 0.8,
              opacity: 0,
            }}
            animate={{
              scale: 1,
              opacity: 1,
            }}
            className={
              "relative w-16 h-16 sm:w-20 sm:h-20 mb-4 sm:mb-6 flex items-center justify-center"
            }
          >
            <div className={"absolute inset-0 border-4 border-indigo-100 rounded-full"} />
            <div
              className={
                "absolute inset-0 border-4 border-transparent border-t-indigo-600 rounded-full animate-spin"
              }
            />
          </motion.div>
        </div>
      </div>
    </div>
  ) : u ? (
    <div className={"min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100"}>
      <Navbar />
      <motion.div
        className={"w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24"}
        initial={"hidden"}
        animate={"visible"}
        variants={M}
      >
        <div
          className={
            "max-w-lg mx-auto bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden border border-red-100"
          }
        >
          <div className={"bg-gradient-to-r from-red-50 to-orange-50 p-6 sm:p-8"}>
            <div className={"flex items-start space-x-3 sm:space-x-4"}>
              <div className={"bg-red-100 rounded-full p-2 sm:p-3 flex-shrink-0"}>
                <CircleAlertIcon className={"w-5 h-5 sm:w-6 sm:h-6 text-red-600"} />
              </div>
              <div className={"flex-1 min-w-0"}>
                <h3 className={"font-bold text-lg sm:text-xl text-red-800 mb-2 sm:mb-3"}>
                  {"Oops! Something went wrong"}
                </h3>
                <p className={"text-red-700 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base"}>
                  {u}
                </p>
                <button
                  className={
                    "inline-flex items-center px-4 sm:px-6 py-2 sm:py-3 bg-red-600 text-white rounded-lg sm:rounded-xl hover:bg-red-700 transition-all duration-300 font-medium shadow-lg hover:shadow-red-200 text-sm sm:text-base"
                  }
                  onClick={() => window.location.reload()}
                >
                  <RefreshCwIcon className={"w-4 h-4 mr-2"} />
                  {"Try Again"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  ) : (
    <div className={"min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100"}>
      <Navbar />
      <section
        className={
          "bg-gradient-to-r from-cyan-500/10 via-blue-500/10 to-purple-500/10 pt-14 bg-slate-800 relative overflow-hidden"
        }
      >
        <div className={"absolute inset-0 bg-black/10"} />
        <div className={"absolute inset-0"}>
          <div
            className={
              "absolute top-0 left-1/4 w-48 h-48 sm:w-72 sm:h-72 bg-white/5 rounded-full blur-3xl"
            }
          />
          <div
            className={
              "absolute bottom-0 right-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-white/5 rounded-full blur-3xl"
            }
          />
        </div>
        <div className={"w-full  mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 relative"}>
          <motion.div initial={"hidden"} animate={"visible"} variants={M} className={"w-full"}>
            <div
              className={
                "flex flex-col space-y-6 lg:space-y-0 lg:flex-row lg:items-start lg:justify-between lg:gap-8"
              }
            >
              <div className={"flex-1"}>
                <h1
                  className={
                    "text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4 leading-tight"
                  }
                >
                  {"My Purchases"}
                </h1>
                <p
                  className={
                    "text-indigo-100 text-base sm:text-lg lg:text-xl max-w-2xl leading-relaxed"
                  }
                >
                  {
                    "Access and manage all your purchased academic projects. Download, review, and get support for your investments."
                  }
                </p>
                <div className={"mt-4 sm:mt-6 flex items-center gap-4 text-indigo-100"}>
                  <div className={"flex items-center gap-2"}>
                    <div className={"w-2 h-2 bg-green-400 rounded-full animate-pulse"} />
                    <span className={"text-sm font-medium"}>
                      {a.length}
                      {" Active Purchases"}
                    </span>
                  </div>
                </div>
              </div>
              <div className={"flex-shrink-0 lg:pt-5"}>
                <Link to={"/projects"}>
                  <Button
                    variant={"secondary"}
                    className={
                      "w-full sm:w-auto flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 border border-white/20 hover:border-white/30 px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg sm:rounded-xl font-medium transition-all duration-300 text-sm sm:text-base"
                    }
                  >
                    <ShoppingBagIcon className={"w-4 h-4 sm:w-5 sm:h-5"} />
                    {"Browse More Projects"}
                  </Button>
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      <div className={"w-full  mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12"}>
        {a.length === 0 ? (
          <motion.div
            className={
              "bg-white rounded-2xl sm:rounded-3xl shadow-xl p-8 sm:p-12 text-center max-w-2xl mx-auto border border-slate-100"
            }
            initial={"hidden"}
            animate={"visible"}
            variants={M}
          >
            <div
              className={
                "w-24 h-24 sm:w-32 sm:h-32 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-6 sm:mb-8"
              }
            >
              <ShoppingBagIcon className={"w-12 h-12 sm:w-16 sm:h-16 text-indigo-500"} />
            </div>
            <h2 className={"text-2xl sm:text-3xl font-bold text-slate-800 mb-3 sm:mb-4"}>
              {"No Purchases Yet"}
            </h2>
            <p
              className={
                "text-slate-600 text-base sm:text-lg mb-8 sm:mb-10 max-w-md mx-auto leading-relaxed"
              }
            >
              {
                "You haven't made any purchases yet. Start exploring our amazing collection of academic projects to boost your learning journey."
              }
            </p>
            <Link to={"/projects"}>
              <Button
                variant={"primary"}
                className={
                  "w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 rounded-lg sm:rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 font-semibold text-base sm:text-lg"
                }
              >
                {"Explore Projects Now"}
              </Button>
            </Link>
          </motion.div>
        ) : (
          <motion.div
            className={
              "grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5"
            }
            variants={Y}
            initial={"hidden"}
            animate={"visible"}
          >
            {a.map((R) => {
              const U = T(R),
                W = U ? C(R.delivery_status) : null,
                B = R.purchase_id || R.id,
                G = p === B;
              return (
                console.log("Purchase:", R.title, "Category:", R.category, "IsHardware:", U),
                (
                  <motion.div
                    key={B}
                    variants={M}
                    className={
                      "relative group w-full h-[450px] bg-white backdrop-blur-lg rounded-3xl p-4 shadow-2xl border border-slate-200 hover:scale-[1.02] transition-all duration-500 ease-out overflow-hidden flex flex-col"
                    }
                    onMouseEnter={() => g(B)}
                    onMouseLeave={() => g(null)}
                  >
                    <div
                      className={
                        "absolute inset-0 bg-gradient-to-r from-indigo-500/5 via-blue-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                      }
                    />
                    <div className={"absolute top-3 left-3 z-10 flex gap-1 flex-wrap"}>
                      <span
                        className={`text-white text-xs font-bold py-1 px-2.5 rounded-full shadow-lg ${U ? "bg-gradient-to-r from-orange-500 to-red-500" : "bg-gradient-to-r from-indigo-500 to-blue-500"}`}
                      >
                        {U ? "Hardware" : "Software"}
                      </span>
                      {R.type === "requirement" && (
                        <span
                          className={
                            "bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs font-bold py-1 px-2.5 rounded-full shadow-lg"
                          }
                        >
                          {"Custom"}
                        </span>
                      )}
                      {U && W ? (
                        <span
                          className={`text-xs font-bold py-1 px-2.5 rounded-full shadow-lg ${W.color}`}
                        >
                          {W.text}
                        </span>
                      ) : (
                        <span
                          className={
                            "bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs font-bold py-1 px-2.5 rounded-full shadow-lg"
                          }
                        >
                          {"Active"}
                        </span>
                      )}
                    </div>
                    <div className={"relative mb-4 group/image flex-shrink-0"}>
                      <div className={"w-full h-48 bg-white rounded-xl overflow-hidden"}>
                        {R.image ? (
                          <img
                            src={`${w}${R.image}`}
                            alt={R.title + "  Codebruh"}
                            className={
                              "w-full h-full object-contain transition-transform duration-700 group-hover/image:scale-110"
                            }
                            onError={(te) => {
                              ((te.target.style.display = "none"),
                                (te.target.parentElement.style.background =
                                  "linear-gradient(to bottom right, rgb(248 250 252), rgb(226 232 240))"));
                            }}
                          />
                        ) : (
                          <div
                            className={
                              "w-full h-full flex items-center justify-center bg-gradient-to-br from-indigo-50 to-purple-50 text-indigo-400 text-xs font-semibold"
                            }
                          >
                            {"Custom Project"}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={"relative z-10 flex-1 flex flex-col justify-between"}>
                      <div className={"flex-1"}>
                        <div className={"mb-2"}>
                          <h3
                            className={
                              "text-slate-900 text-[15px] font-bold leading-tight line-clamp-2"
                            }
                          >
                            {R.title}
                          </h3>
                        </div>
                        <div className={"mb-3"}>
                          <p className={"text-slate-600 text-[10px] line-clamp-1 leading-relaxed"}>
                            {R.description}
                          </p>
                        </div>
                        {U && (
                          <div
                            className={
                              "mb-3 p-2 bg-gradient-to-r from-orange-50 to-red-50 rounded-xl border border-orange-200"
                            }
                          >
                            <div className={"space-y-1"}>
                              <div className={"flex justify-between items-center"}>
                                <span className={"text-xs text-slate-600 font-medium"}>
                                  {"Tracking:"}
                                </span>
                                {O(R)}
                              </div>
                              <div className={"flex justify-between items-center"}>
                                <span className={"text-xs text-slate-600 font-medium"}>
                                  {"Status:"}
                                </span>
                                <span className={"text-xs text-slate-800 font-semibold capitalize"}>
                                  {R.delivery_status || "Order Placed"}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className={"flex-shrink-0"}>
                        <div className={"flex items-center gap-2 mb-3"}>
                          <span
                            className={
                              "bg-green-500 text-white text-xs font-bold py-0.5 px-1.5 rounded-full"
                            }
                          >
                            {"Paid"}
                          </span>
                          {U && (
                            <span
                              className={
                                "bg-orange-500 text-white text-xs font-bold py-0.5 px-1.5 rounded-full"
                              }
                            >
                              {"Physical"}
                            </span>
                          )}
                        </div>
                        <div className={"flex gap-2"}>
                          <Link
                            to={R.type === "requirement" ? "/requests" : `/purchases/${B}`}
                            className={
                              "flex-1 bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-2 px-4 rounded-xl font-semibold hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 hover:shadow-lg text-center text-sm"
                            }
                          >
                            {"View Details"}
                          </Link>
                          <button
                            onClick={N}
                            className={
                              "px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl font-semibold transition-all duration-300 text-sm"
                            }
                          >
                            {"Help"}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className={"absolute inset-0 overflow-hidden pointer-events-none"}>
                      {[...Array(4)].map((te, ne) => (
                        <div
                          key={ne}
                          className={`absolute w-1 h-1 bg-indigo-400/30 rounded-full transition-all duration-1000 ${G ? "animate-pulse" : ""}`}
                          style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animationDelay: `${ne * 0.2}s`,
                          }}
                        />
                      ))}
                    </div>
                  </motion.div>
                )
              );
            })}
          </motion.div>
        )}
      </div>
    </div>
  );
};
export { PurchasesPage };
